import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
/**
 * According to has_prepacks_available
 * this only exists on certain endpoints.
 * Ensure that the product passed in actually has
 * the field if this would be used in other endpoints in the
 * future.
 */ export var isPrePackProduct = function(product) {
    return product === null || product === void 0 ? void 0 : product.has_pre_packs_available;
};
export var isPrePackProductOption = function(productOption) {
    return productOption.type === IProductOption.Type.PRE_PACK;
};
